
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planting-projects/[uri]",
      function () {
        return require("private-next-pages/planting-projects/[uri]/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planting-projects/[uri]"])
      });
    }
  